/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportEffectiveLaborCosts$Params {
  projectIds?: Array<string>;
  costTypeIds?: Array<string>;
  budgetIds?: Array<string>;
  wpIds?: Array<string>;
  userIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  sorting?: Array<'id' | '-id' | 'from' | '-from' | 'to' | '-to' | 'projectName' | '-projectName' | 'budgetName' | '-budgetName' | 'total' | '-total' | 'totalSeconds' | '-totalSeconds' | 'workPackageName' | '-workPackageName' | 'laborActivityName' | '-laborActivityName' | 'laborName' | '-laborName' | 'username' | '-username'>;
}

export function exportEffectiveLaborCosts(http: HttpClient, rootUrl: string, params?: ExportEffectiveLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, exportEffectiveLaborCosts.PATH, 'get');
  if (params) {
    rb.query('projectIds', params.projectIds, {});
    rb.query('costTypeIds', params.costTypeIds, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('userIds', params.userIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

exportEffectiveLaborCosts.PATH = '/v0/effectiveLaborCost/export';
